export const GET_SELECTED_PARTNERID = 'GET_SELECTED_PARTNERID';

export const getSelectedPartnerId = (show) => ({
  type: GET_SELECTED_PARTNERID,
  payload: show,
});